/**
 * Testimonials section
 */
(function($, window) {
    $(document).on('cms.ready', ready);
    // $(document).ready(ready);

    let logged_in = false; // Nice-to-have: Logged in as a Contenda variable.

    function ready() {
        logged_in = $('body.logged-in').length;

        if(logged_in) {
            // Set up intersect listener on document since that's the only way we can listen to newly added elements
            $(document).on('cms.intersect', '.sectionCookiebotDeclaration', function(evt, entry, $elm) {
                initSection(0, $elm);
            });
        }
        $('.sectionCookiebotDeclaration').each(initSection);
    }

    function initSection(idx, elm) {
        let $section = $(elm),
            $child = $section.find('.cookiebot-declaration__content');

        let cookiebot = $child.attr('cookiebot'),
            ignore = $child.attr('ignore');

        if(ignore) {
            return;
        }

        if(cookiebot != Contenda.settings.cookiebot) {
            $section.find('#CookieDeclaration').src = 'https://consent.cookiebot.com/'+Contenda.settings.cookiebot+'/cd.js';
        }
    }

})(jQuery, window);